import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorAccountingLinesSearch = () => {
  const accountingLinesSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/transaction/fund-accounting/lines-search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { accountingLinesSearch }
}

export default InteractorAccountingLinesSearch
